import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { API_WEB_URLS } from "../../constants/constAPI";

const VisitorLeadModal = () => {
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    // 1. Check if user is logged in
    const userDataStr = localStorage.getItem("userData");
    let isLoggedIn = false;
    if (userDataStr) {
      try {
        const userData = JSON.parse(userDataStr);
        const parsedId = userData.Id || userData.id || userData.UserId;
        if (parsedId && String(parsedId).trim() !== "" && String(parsedId) !== "0") {
          isLoggedIn = true;
        }
      } catch (e) {}
    }

    // 2. Check if modal was already submitted or dismissed in session
    const isDismissed = sessionStorage.getItem("leadModalDismissed");
    const isSubmitted = localStorage.getItem("leadSubmitted");

    // Only show modal if NOT logged in and NOT dismissed/submitted
    if (!isLoggedIn && !isDismissed && !isSubmitted) {
      // Small delay for smooth entry after website load
      const timer = setTimeout(() => {
        setShow(true);
      }, 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    sessionStorage.setItem("leadModalDismissed", "true");
    setShow(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!mobileNo || mobileNo.trim() === "") {
      setMessage("Please enter your mobile number.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const formData = new FormData();
      formData.append("Name", name ? name.trim() : "");
      formData.append("MobileNo", mobileNo.trim());

      const url = `${API_WEB_URLS.BASE}WebsiteLeads/SaveLead`;
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data && (data.success || data.Success)) {
        localStorage.setItem("leadSubmitted", "true");
        sessionStorage.setItem("leadModalDismissed", "true");
        setMessage("Thank you! Your contact details have been submitted.");
        setTimeout(() => {
          setShow(false);
        }, 1500);
      } else {
        // If mobile already registered or error message
        const errMsg = data?.message || data?.Message || "Mobile number already registered or invalid.";
        setMessage(errMsg);
        // Mark as dismissed so modal doesn't keep disturbing visitor
        sessionStorage.setItem("leadModalDismissed", "true");
      }
    } catch (err) {
      console.error("Error saving lead:", err);
      setMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      className="visitor-lead-modal"
    >
      <Modal.Header closeButton style={{ borderBottom: "none", padding: "15px 20px 0" }}>
        <Modal.Title style={{ fontSize: "1.25rem", fontWeight: "600", color: "#333" }}>
          Welcome to Wedding Knot! ✨
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "10px 25px 25px" }}>
        <p style={{ fontSize: "0.9rem", color: "#666", marginBottom: "18px" }}>
          Stay updated with our latest wedding collections, exclusive offers & assistance!
        </p>

        {message && (
          <div
            className={`alert ${
              message.includes("Thank you") ? "alert-success" : "alert-info"
            }`}
            style={{ fontSize: "0.85rem", padding: "8px 12px", marginBottom: "15px" }}
          >
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label style={{ fontSize: "0.85rem", fontWeight: "500", color: "#444", marginBottom: "5px" }}>
              Your Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{ fontSize: "0.9rem", padding: "8px 12px" }}
            />
          </div>

          <div className="form-group mb-4">
            <label style={{ fontSize: "0.85rem", fontWeight: "500", color: "#444", marginBottom: "5px" }}>
              Mobile Number <span style={{ color: "#d9534f" }}>*</span>
            </label>
            <input
              type="tel"
              className="form-control"
              placeholder="Enter mobile number"
              value={mobileNo}
              onChange={(e) => setMobileNo(e.target.value)}
              required
              style={{ fontSize: "0.9rem", padding: "8px 12px" }}
            />
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <button
              type="button"
              className="btn btn-link text-muted"
              onClick={handleClose}
              style={{ fontSize: "0.85rem", textDecoration: "none", paddingLeft: 0 }}
            >
              Skip for now
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
              style={{
                backgroundColor: "#a749ab",
                borderColor: "#a749ab",
                fontSize: "0.9rem",
                padding: "8px 22px",
                borderRadius: "4px",
              }}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default VisitorLeadModal;
